/**
 * PhoenixSimpleForm
 *
 * A web component to wrap a <form> element. On form post failure,
 * error message will show in <span> element.
 *
 * Sample markup:
 *
 *   <phoenix-simple-form
 *     action="/.api/add-email-to-mailing-list"
 *     opts={custom request opts}
 *     config={server response keys and values}
 *     error-message="An error occurred.">
 *     <span>Error Message</span>
 *     <form>
 *       <input name="email">
 *       <input type="submit">
 *     </form>
 *   </phoenix-simple-form>
 *
 */
'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:simpleForm');

getDependencyClass('phoenix-page').then((pageClass) => {
    class PhoenixSimpleForm extends pageClass.PhoenixElement {
        connectedCallback() {
            this.form = this.querySelector('form');
            this.action = this.getAttr('action', { required: true });
            this.opts = this.getAttr('opts');
            this.error = this.querySelector('span');
            this.form.addEventListener('submit', (evt) => {
                evt.preventDefault();
                this._submitListener();
            });
        }

        disconnectedCallback() {
            this.form.removeEventListener('submit', this.submitListener);
        }

        _submitListener() {
            var formData = new FormData(this.form);
            var body = this._urlencodeFormData(formData);
            var opts = pageClass.basicAuth.getRequestOptions();
            var customOpts = this.opts;
            if (customOpts === null) {
                opts.method = 'POST';
                if (!opts.headers) {
                    opts.headers = {};
                }
                opts.headers['Content-Type'] = 'application/json';
            } else {
                opts = JSON.parse(customOpts);
            }
            opts.body = body;

            this._submit(opts);
        }

        _urlencodeFormData(formData) {
            var params = new URLSearchParams();
            for (var pair of formData.entries()) {
                typeof pair[1] === 'string' && params.append(pair[0], pair[1]);
            }
            this._addCheckboxFormData(params);
            return params.toString();
        }

        _addCheckboxFormData(params) {
            var checkboxes = this.querySelectorAll('input[type=checkbox]');
            checkboxes.forEach((checkbox) => {
                if (!checkbox.checked) {
                    params.append(checkbox.name, checkbox.checked);
                }
            });
        }

        _submit(opts) {
            fetch(this.action, opts)
                .then(
                    (successResponse) => {
                        return successResponse.json();
                    },
                    (errorResponse) => {
                        return this.showError(errorResponse.message);
                    }
                )
                .then((actualResponse) => {
                    this._handleResponse(actualResponse);
                });
        }

        _handleResponse(response) {
            if (!response.success) {
                var config = JSON.parse(this.getAttribute('config'));
                try {
                    var value = config.find((msg) => msg.key === response.message).value;
                    this._showError(value);
                } catch (e) {
                    this._showError('Error!');
                }
            } else {
                window.location.reload();
            }
        }

        _showError(msg) {
            this.error.innerHTML = msg;
        }
    }
    window.customElements.define('phoenix-simple-form', PhoenixSimpleForm);
    measure.end();
});
